import { useField } from "formik";
import { forwardRef, type InputHTMLAttributes } from "react";

import {
  Input as BaseInput,
  type InputProps,
} from "@src/shared/components/forms/Input";

export interface FormikInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "name"> {
  name: string;
  label?: InputProps["label"];
  hint?: InputProps["hint"];
  containerClassName?: InputProps["containerClassName"];
}

/**
 * Formik-integrated text input. Drop-in replacement for the legacy
 * `<InputFormik />` from `@el8/vital-formik` — surfaces validation errors
 * after the field has been touched.
 */
export const FormikInput = forwardRef<HTMLInputElement, FormikInputProps>(
  ({ name, ...props }, ref) => {
    const [field, meta] = useField(name);
    const error = meta.touched && meta.error ? meta.error : undefined;

    return (
      <BaseInput
        {...props}
        {...field}
        ref={ref}
        value={field.value ?? ""}
        error={error}
      />
    );
  },
);
FormikInput.displayName = "FormikInput";
